export const emptyString = "";
export const emptyObject = {};
export const emptyArray = [];
export const emptyFunction = () => {};
